import {CustomView} from "../utils/CustomView";

export class NotificationService {
  constructor() {
    this._modalWindow = CustomView.modalWindow;
    this.sceneModalOpened = false;
  }

  clear() {
    SceneManager._scene.removeCaptionWindows();
  };

  showModal(text) {
    this._modalWindow.modalText = text;
    this._modalWindow.show();
  }

  showPopup(text) {
    SceneManager._scene.showDefaultPopup(text);
  }

  showText(text) {
    SceneManager.callPopup(text);
  }

  showSceneModal(text) {
    SceneManager._scene.showDefaultModal(text);
    this.sceneModalOpened = true;
  }

  waifuUnlocked() {
    Yosemite.Audio.questComplete();
    this.showSceneModal('New Waifu unlocked!');
  }

  pictureUnlocked(pictureId) {
    Yosemite.Gallery.enablePicture(pictureId);
    YsServices.notificationService.showSnackbar('Picture unlocked!');
  }

  showSnackbar(text) {
    const txtArray = (Array.isArray(text)) ? text : [text];
    SceneManager._scene.showSnackbar(txtArray);
  }

  completeQuest() {
    this.showSnackbar('Quest completed!');
    Yosemite.Audio.questComplete();
  }

  activateQuest() {
    this.showSnackbar('New quests available!');
    Yosemite.Audio.questActivate();
  }

  raiseStat(text, setWait = false) {
    if (setWait) {
      $gameMap._interpreter.wait(60);
    }

    this.showSnackbar(text);
    Yosemite.Audio.raiseStat();
  }

  earningInfo(money) {
    Yosemite.Audio.addMoney();
    this.showSnackbar(`You have earned ${money} $`);
  }
}
